module.exports = __webpack_public_path__ + "img/img5_11.0aac3a04.jpeg";